import { PrivacySettings, CookiesBannerAcknowledgementState } from '../models';

export const INITIAL_PRIVACY_SETTINGS_COOKIE: PrivacySettings = {
  cookiesBannerState: CookiesBannerAcknowledgementState.NO_ACTION,
};
